import { useReadQuery } from '@apollo/client';
import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.tsx';
import { PostIcon } from '@synoptic/ui-kit/icons/react/post.tsx';
import { StreamState } from '@/__generated__/graphql.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useMe } from '@/routes/_app/use-me.ts';
import {
  AuthenticatedStreamLoaderData,
  useStreamLoaderData,
} from '../_app.p.streams_.$id/loader.ts';
import { emptyState } from './page.css.ts';

export const EmptyStreamPostsFeed = () => {
  const me = useMe();

  const { streamQueryRef } =
    useStreamLoaderData() as AuthenticatedStreamLoaderData;
  const { data } = useReadQuery(streamQueryRef);
  const stream = data?.stream;

  const isDraft = stream?.streamState === StreamState.Draft;
  const isMe = me.username === stream?.author.username;

  const heading =
    isDraft && isMe ? 'This stream is saved as a draft' : 'No data yet';
  const description =
    isDraft && isMe
      ? stream.customTargetsData
        ? 'Connect an API and add your first post to enable publishing.'
        : 'Add your first post manually or connect an API to enable publishing.'
      : null;

  return (
    <EmptyState
      className={emptyState}
      illustration={<PostIcon />}
      heading={heading}
      description={description}
      action={
        isDraft && isMe ? (
          <Button variant={'secondary'} size={'small'} asChild>
            <Link to={paths.makeStreamApi(stream.id)}>Connect API</Link>
          </Button>
        ) : undefined
      }
    />
  );
};
